<template>
  <div>
    <template v-if="type === 'dropdown-op'">
      <div v-gutter="8" class="inline-block">
        <template v-if="config">
          <gj-button
              v-for="item in textConfig"
              :key="item.label"
              type="text"
              @click="item.click">
            {{item.label}}
          </gj-button>
        </template>
        <slot v-else></slot>
      </div>
      <gj-dropdown
          v-if="$slots.dropdown || (config && dropdownConfig.length > 0)"
          placement="bottom-end"
          trigger="click"
          class="inline-block dropdown"
          ref="dropdown"
          >
        <gj-tooltip content="更多操作">
          <gj-button size="mini" class="dropdown-btn" id="dropdown">
            <!-- <i class="el-icon-arrow-down dropdown-icon"></i> -->
            <i class="iconfont icongengduo1"></i>
          </gj-button>
        </gj-tooltip>
        <template #dropdown>
          <template v-if="config">
            <gj-dropdown-item
                v-for="item in dropdownConfig"
                :key="item.label"
                type="text"
                @click="item.click">
              {{item.label}}
            </gj-dropdown-item>
          </template>
          <slot v-else name="dropdown"></slot>
        </template>
      </gj-dropdown>
    </template>
    <el-button-group v-else>
      <slot></slot>
    </el-button-group>
  </div>
</template>

<script>
  export default {
    name: "gj-button-group",
    props: {
      type: {
        type: String,
        default: 'default',
        validator: function (value) {
          return ['default', 'dropdown-op'].indexOf(value) !== -1
        }
      },
      config: {
        type: Array,
        default: null
      },
      showLength:{
        type:Number,
        required:false
      }
    },
    computed: {
      textConfig() {
        if (!this.config || this.config.length === 0) {
          return [];
        }
        const config = this.config.filter(item => !item.show || item.show());
        if(this.showLength && this.showLength > 0){
          return config.slice(0, this.showLength);
        }
        if (config.length <= 2) {
          return config;
        } else {
          return [config[0], config[1]];
        }
      },
      dropdownConfig() {
        if(this.showLength){
          if(this.config.length <  this.showLength){
            return [];
          }
          return this.config.filter(item => !item.show || item.show()).filter((item, index) => index > this.showLength-1);
        }
        if (!this.config || this.config.length < 2) {
          return [];
        }
        return  this.config.filter(item => !item.show || item.show()).filter((item, index) => index > 1);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .dropdown {
    margin-left: 12px;
  }
  .dropdown-btn {
    padding: 2px;
    //transform: rotate(90deg);
    // background-color: #fff;
    background-color: rgba($color: #fff, $alpha: 0);
    border: none;
    font-size: 18px;
    color: #1F6EEF;
    position: relative;
    top: 1px;
  }
  .dropdown-btn:hover{
    border: none;
    background: #EDF7FF;
  }
  .dropdown-icon {
    color: #1F6EEF
  }
</style>
